"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ella(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5548 9.909L12 8.355L10.4348 9.9195L8.81175 8.2965L12 3.75L15.21 8.25375L13.5548 9.909ZM9.8925 10.4625L8.355 12L9.909 13.5548L8.292 15.1718L3.75 12L8.2425 8.8125L9.8925 10.4625ZM14.0805 13.5653L15.645 12L14.097 10.452L15.7665 8.7825L20.25 12L15.717 15.2017L14.0805 13.5653ZM10.452 14.0978L12 15.645L13.5375 14.1075L15.174 15.7448L12 20.25L8.847 15.702L10.452 14.0978ZM12 9.39525L14.604 12L12 14.604L9.396 12L12 9.39525Z", fill: color }));
}
exports["default"] = ella;
//# sourceMappingURL=ella.js.map